import React from "react";
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faTrophy, faMedal, faHome, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from "./../../assets/Kunjpuraschl.png";

const SainikSchoolKunjpura = () => {
  const houses = [
    { name: 'Chillianwala', color: 'Green', bgColor: '#28a745' },
    { name: 'Kurukshetra', color: 'Red', bgColor: '#dc3545' },
    { name: 'Panipat', color: 'Yellow', bgColor: '#ffc107' },
    { name: 'Thaneshwar', color: 'Blue', bgColor: '#007bff' },
    { name: 'Shakargarh', color: 'Pink', bgColor: '#e83e8c' },
    { name: 'Chhamb', color: 'Purple', bgColor: '#6f42c1' }
  ];

  const honors = [
    { name: 'Ashok Chakra', count: '02' },
    { name: 'Mahavir Chakra', count: '01' },
    { name: 'Shaurya Chakra', count: '02' },
    { name: 'Sena Medal', count: '02' },
    { name: 'Asian Games Gold Medal', count: '01' },
    { name: 'Arjuna Award', count: '01' },
    { name: 'National Award (Teachers)', count: '03' },
    { name: 'Raksha Mantri Trophy', count: '09' }
  ];

  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faSchool} className="me-2" />
            Sainik School, Kunjpura, Karnal
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <div className="mb-4">
          <img 
            src={img} 
            alt="Sainik School Kunjpura" 
            style={{
              width: '100%',
              height: '370px',
              objectFit: 'cover',
              borderRadius: '20px',
              boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
            }}
          />
        </div>

        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faSchool} className="me-2" />
              About the School
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                The Sainik School Kunjpura has been established in Northern Central of Haryana State with aim to provide best education to the children of Haryana State. Sainik School Kunjpura is one of the first five schools established by the Sainik Schools Society, New Delhi in 1961. This school was founded by (late) Shri V.K. Krishna Menon, the then Defence Minister of India, on 24th July, 1961. The School is spread over an area of 276 acres of land located in Village Kunjpura which is 8 Kms away from Karnal Town, out of which 154 acre of land is within the boundary wall of the school. Young saplings were nurtured with love, affection and determination by none other than (Late) Lt Col EJ Simeon.
              </p>
            </div>
            
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                The School cadets are sub divided into four Main Houses and two Holding Houses. The names of these houses are based on famous cities and battles fought by the Indians.
              </p>
            </div>
          </CardBody>
        </Card>

        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faHome} className="me-2" />
              School Houses
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="row">
              {houses.map((house, index) => (
                <div key={index} className="col-md-6 col-lg-4 mb-3">
                  <div 
                    className="p-3 text-center rounded"
                    style={{
                      background: house.bgColor,
                      color: 'white',
                      minHeight: '80px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                    }}
                  >
                    <h6 className="mb-1 fw-bold">{house.name}</h6>
                    <small>({house.color})</small>
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>

        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
              School Motto & Aim
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                <strong>Moto of Sainik School Kunjpura:</strong> The motto of the school is <strong>'SIDDHIM SANNADH'</strong> which translates to <strong>'Ready to Accomplish'</strong> and the aim is to send maximum students to join Defence Forces through NDA or other entries.
              </p>
            </div>
            
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                The primary aim of the school is to provide 360* round shape in personality of its student and prepare them academically, mentally and physically for entry into the National Defence Academy. The school is known for its committed nature towards the dynamic efforts for its students. It enables boys from economically weaker sections of the society to take up an illustrious officer career in the Armed Forces of the nation. Character building, dedication, patriotic outlook and esprit-de-corps are the qualities which are promoted by the Sainik Schools.
              </p>
            </div>
            
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                The school is affiliated to CBSE, New Delhi. The school prepares boys for compulsory science stream for all India Secondary School and all India Senior Secondary School Certificate Examinations. Sports and other co-curricular activities are given equal emphasis along with the academics in the school so as to develop an all round balanced personality of leadership by making NCC training compulsory for all the boys of the school. It helps the boys to grow as well disciplined youth in the country. Sainik School Kunjpura basically caters for the boys of the state of Haryana and Union Territory of Delhi but certain seats are available for outsider also. There is a very liberal scheme of scholarship which is provided by the concerned State Govt./Union Territory Administration on the basis of income slabs of boy's parents. The school is a member of the Indian Public Schools Conference (IPSC).
              </p>
            </div>
            
            <div className="mb-0">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                The school has opened its doors for the girl cadets from the academic session 2021-22 which reflects the Government's commitment of promoting gender equality and fostering gender awareness among the student community. The school is playing pivotal role in Nation building by nurturing the future of the country to prepare them to be good defence officers and responsible citizens of the country.
              </p>
            </div>
          </CardBody>
        </Card>

        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faTrophy} className="me-2" />
              Peerless Triumph
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="mb-4">
              <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                Haryana as a State has been in the forefront in sending its valiant subjects to the Armed Forces but remained deficient in the Officer Cadre. Sainik School Kunjpura has amply filled this gap and removed regional imbalance by sending more than 800 of its cadets to the National Defence Academy, and approximately an equal number through direct entry to IMA, OTA, AFA and the Naval Academy. It would be worth mentioning here that a cadet of the school has risen to the highest rank of the Indian Army. Sainik School Kunjpura has the proud privilege of annexing the 'RAKSHA MANTRI TROPHY' nine times since the inception of the School. The students of school have also been in the leading role in the fields of Politics, Civil services, Banking, Railways and many more.
              </p>
            </div>
            
            <div>
              <h5 className="mb-3" style={{ color: '#dc3545', fontWeight: '600' }}>Honors and Awards:</h5>
              <div className="row">
                {honors.map((honor, index) => (
                  <div key={index} className="col-md-6 col-lg-3 mb-2">
                    <div 
                      className="p-2 text-center rounded"
                      style={{
                        background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                        color: 'white',
                        minHeight: '60px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 4px 15px rgba(220,53,69,0.2)',
                        transition: 'all 0.3s'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(220,53,69,0.3)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(220,53,69,0.2)';
                      }}
                    >
                      <FontAwesomeIcon 
                        icon={faMedal} 
                        style={{ fontSize: '1.5rem', marginBottom: '5px' }}
                      />
                      <h6 className="mb-0 fw-bold" style={{ fontSize: '0.9rem' }}>{honor.name}</h6>
                      <small>{honor.count}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default SainikSchoolKunjpura;
